<template>
    <el-header id="nav">
        <a href="https://wtatennis.sharepoint.com/sites/PlayerZone">
            <img v-if="useLists" src="../assets/WTA-Player-Zone_Headers.png" alt="brand logo" width="100%"/>
            <img v-else src="../assets/WTA-Zone_Headers.png" alt="brand logo" width="100%"/>
        </a>
        <div style="position: absolute; top: 10px;">
            <el-button @click="goToHome" type="primary" icon="el-icon-house" title="Back To Home" style="float: left; margin-left: 10px;" plain>Home</el-button>
        </div>
    </el-header>
</template>

<script>
export default {
    data() {
        return {
            mode: process.env.VUE_APP_APPLICATION_MODE,
            useLists: USE_LISTS
        };
    },
    methods: {
        goToHome() {
            if( this.useLists ){
                window.location.href = process.env.VUE_APP_URL_SHAREPOINT_HOME;    
                return true;
            }
            window.location.href = process.env.VUE_APP_URL_HOME;
            return true;
        },
    },
};
</script>

<style lang="scss">
.purple-background {
    background-color: #7814FF;
    color: white;
}
#nav {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    margin-bottom: 75px;
    padding: 0;
}

.title {
    color: white;
    font-size: 20px;
    font-weight: 600;
    padding: 16px;
    text-decoration: none !important;
}

.production-indicator {
    position: absolute;
    right: 10px;
    padding: 5px 20px;
    font-weight: bold;
    border-radius: 5px;
}

.production-indicator.production {
    background-color: white;
    color: red;
}

.production-indicator.review {
    background-color: white;
    color: green;
}

.production-indicator.development {
    background-color: white;
    color: orange;
}
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue